export default __webpack_public_path__ + "static/media/1.d1427794.png";